// This file was auto-generated by Fern from our API Definition.
import * as FernIr from "../../../index.mjs";
export const Environments = {
    singleBaseUrl: (value) => {
        return Object.assign(Object.assign({}, value), { type: "singleBaseUrl", _visit: function (visitor) {
                return FernIr.Environments._visit(this, visitor);
            } });
    },
    multipleBaseUrls: (value) => {
        return Object.assign(Object.assign({}, value), { type: "multipleBaseUrls", _visit: function (visitor) {
                return FernIr.Environments._visit(this, visitor);
            } });
    },
    _visit: (value, visitor) => {
        switch (value.type) {
            case "singleBaseUrl":
                return visitor.singleBaseUrl(value);
            case "multipleBaseUrls":
                return visitor.multipleBaseUrls(value);
            default:
                return visitor._other(value);
        }
    },
};
